module.exports = __webpack_public_path__ + "f73a1bed515ce46c0f5a2e002fef5ebc.svg";